import { render, staticRenderFns } from "./ConfigurarAlertaModal.vue?vue&type=template&id=7fd35e24&"
import script from "./ConfigurarAlertaModal.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarAlertaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7fd35e24', component.options)
    } else {
      api.reload('7fd35e24', component.options)
    }
    module.hot.accept("./ConfigurarAlertaModal.vue?vue&type=template&id=7fd35e24&", function () {
      api.rerender('7fd35e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/ConfigurarAlertas/ConfigurarAlertaModal.vue"
export default component.exports